export default "__VITE_ASSET__e207b8bb__"